"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnit = exports.isUnit = exports.CeriseUnit = exports.Unit = void 0;
var Unit;
(function (Unit) {
    Unit["BIN"] = "BIN";
    Unit["CAM"] = "CAM";
    Unit["CBG"] = "CBG";
    Unit["CEBR"] = "CEBR";
    Unit["CEDE"] = "CEDE";
    Unit["CEES"] = "CEES";
    Unit["CEIT"] = "CEIT";
    Unit["CEUK"] = "CEUK";
    Unit["CLE"] = "CLE";
    Unit["CTM"] = "CTM";
    Unit["FATV"] = "FATV";
    Unit["FDI"] = "FDI";
    Unit["FRGTS"] = "FRGTS";
    Unit["FROMM"] = "FROMM";
    Unit["GALA"] = "GALA";
    Unit["GEO"] = "GEO";
    Unit["HBZ"] = "HBZ";
    Unit["HCO"] = "HCO";
    Unit["IDE"] = "IDE";
    Unit["ICI"] = "ICI";
    Unit["JDD"] = "JDD";
    Unit["JDM"] = "JDM";
    Unit["JDN"] = "JDN";
    Unit["MAD"] = "MAD";
    Unit["MLK"] = "MLK";
    Unit["MVO"] = "MVO";
    Unit["NEON"] = "NEON";
    Unit["NGE"] = "NGE";
    Unit["PECO"] = "PECO";
    Unit["PFEM"] = "PFEM";
    Unit["PMEDIA"] = "PMEDIA";
    Unit["PMO"] = "PMO";
    Unit["PTVS"] = "PTVS";
    Unit["QUOI"] = "QUOI";
    Unit["SESH"] = "SESH";
    Unit["SHG"] = "SHG";
    Unit["TGL"] = "TGL";
    Unit["TMA"] = "TMA";
    Unit["TRV"] = "TRV";
    Unit["TVP"] = "TVP";
    Unit["TVS"] = "TVS";
    Unit["VOICI"] = "VOICI";
    Unit["TESTUNIT"] = "TEST-UNIT";
})(Unit = exports.Unit || (exports.Unit = {}));
var CeriseUnit;
(function (CeriseUnit) {
    CeriseUnit["CEBR"] = "CEBR";
    CeriseUnit["CEDE"] = "CEDE";
    CeriseUnit["CEES"] = "CEES";
    CeriseUnit["CEIT"] = "CEIT";
    CeriseUnit["CEUK"] = "CEUK";
    CeriseUnit["FRGTS"] = "FRGTS";
    CeriseUnit["FROMM"] = "FROMM";
})(CeriseUnit = exports.CeriseUnit || (exports.CeriseUnit = {}));
function isUnit(maybeUnit) {
    return Object.entries(Unit).some(([, unit]) => unit === maybeUnit);
}
exports.isUnit = isUnit;
function assertUnit(maybeUnit) {
    if (!isUnit(maybeUnit)) {
        throw new Error(`The unit "${maybeUnit}" does not exist.`);
    }
    return maybeUnit;
}
exports.assertUnit = assertUnit;
//# sourceMappingURL=unit.js.map